export default __webpack_public_path__ + "static/notification-6cfe3bc1a222c76f767d0fd71c97c23e.png";